(function($) {
  'use strict';

  const init = {
    dom: function() {
      this.$html = $('html');
      this.$header = $('#header');
      this.$pageBanner = $('#page-banner');
      this.$bannerContent = $('.page-banner__content');
      this.$slider = $('[data-slider]');
      this.$testimonials = $('#testimonials');
      this.section = '.section';
      this.$lazyload = $('.lazyload');
      this.$inViewport = $('.js-in-viewport');
      this.$process = $('[data-process]');
      this.$marquee = $('[data-marquee]');
      this.$footerCallouts = $('.footer-callout__items');
      this.$links = $('a');
    },

    settings: {
      windowWidth: window.innerWidth,
      headerHeight: 0,
      headerOffset: 0,
    },

    class: {
      loaded: 'loaded',
      headerFill: 'header-fill',
      menuOpen: 'menu-open'
    },

    headerShowHide: function() {
      const _ = this;
      let didScroll = false;
      let st = window.scrollY;
      let lastScrollTop = 0;
      let headerHeight = 80;
      let offset = 0;

      const options = ['a', 'abbr', 'b', 'blockquote', 'br', 'button', 'caption', 'cite', 'code', 'div', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'li', 'ol', 'p', 'pre', 'small', 'span', 'strong', 'sub', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul'];

      $(window).on('load resize', function(event) {
        if (_.$pageBanner.length) {
          headerHeight = _.$header.outerHeight() + 2;
          offset = 0;
        }
        if (event.type === 'load') {
          setTimeout(function() {
            checkPos();
          }, 250);
        }
        else {
          checkPos();
        }
      });

      setTimeout(function() {
        lastScrollTop = st;
        $(window).on('scroll', function () {
          st = window.scrollY;
          didScroll = true;
          hasScrolled();
        });
      }, 500);

      function checkPos() {
        st = window.scrollY;

        if (st > headerHeight && st > 0) {
          _.$html.addClass(_.class.headerFill);
        } else {
          _.$html.removeClass(_.class.headerFill);
        }
      }

      function hasScrolled() {
        checkPos();

        // Scroll Down
        if (st > lastScrollTop && st > 0) {
          _.$header.css('transition', 'none');
          if (offset < headerHeight) {
            offset = offset + (st - lastScrollTop);
          }
        }
        // Scroll Up
        else {
          _.$header.css('transition', 'all .2s,transform 0.4s');
          offset = 0;
        }

        _.$header.css('transform', 'translateY(-' + offset + 'px)');

        lastScrollTop = st;
      }
    },

    slider: function() {
      this.$slider.each(function() {
        let $this = $(this);
        let settings = $this.data('slider');
        let autoplaySpeed = $this.attr('data-speed') ? parseInt($this.data('speed')) : 2000;

        $this.on('init', function(event, slick) {
          $(slick.$slides[slick.currentSlide]).addClass('slick-animate');
        });

        $this.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          $(slick.$slides[nextSlide]).addClass('slick-animate');
        });

        $this.on('afterChange', function(event, slick, currentSlide) {
          let previousSlide = currentSlide - 1;
          if (previousSlide < 0) {
            previousSlide = slick.$slides.length - 1;
          }
          setTimeout(function() {
            $(slick.$slides[previousSlide]).removeClass('slick-animate');
          }, (slick.originalSettings.autoplaySpeed / 2));
        });

        $this.slick({
          autoplay: true,
          autoplaySpeed: autoplaySpeed,
          fade: true,
          speed: 2000,
          arrows: settings.indexOf('no-arrows') >= 0 ? false : true,
          dots: settings.indexOf('no-dots') >= 0 ? false : true,
          pauseOnDotsHover: false,
        });
      });
    },

    testimonials: function() {
      this.$testimonials.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        arrows: false,
        dots: true,
        pauseOnDotsHover: true
      });
    },

    lazyload: function() {
      this.$lazyload.lazyload();
    },

    easterEgg: function() {
      const _ = this;
      const patterns = {
        'konami' : ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'],
        'tyson' : ['0', '0', '7', '3', '7', '3', '5', '9', '6', '3']
      };

      Object.keys(patterns).forEach(key => {
        let pattern = patterns[key];
        let current = 0;

        let keyHandler = function(event) {

          // If the key isn't in the pattern, or isn't the current key in the pattern, reset
          if (pattern.indexOf(event.key) < 0 || event.key !== pattern[current]) {
            current = 0;
            return;
          }

          // Update how much of the konami is complete
          current++;

          // If complete, alert and reset
          if (pattern.length === current) {
            current = 0;
            let theme = _.$html.data('theme');
            let bannerText = _.$bannerContent.text();
            let newText = bannerText;
            if (key === 'tyson') {
              newText = bannerText.replaceAll('s', 'th');
            }

            _.$html.attr('data-theme', key);
            _.$bannerContent.text(newText);

            setTimeout(function() {
              _.$html.attr('data-theme', theme);
              _.$bannerContent.text(bannerText);
            }, 5000);
          }
        }

        // Listen for keydown events
        document.addEventListener('keydown', keyHandler, false);
      });
    },

    inViewport: function() {
      const _ = this;
      $(window).on('load scroll resize', function() {
        _.$inViewport.each(function() {
          let $this = $(this);
          let pos = viewportPosition($this);
          switch (pos) {
            case 'entered':
            case 'in':
              $this.addClass('in');
              break;
          }
        })
      });
    },

    process: function() {
      const _ = this;
      _.$process.each(function() {
        let $this = $(this);
        let slider;
        $(window).on('load resize', function() {
          if ($(window).width() <= jcms.breakpoints.fluid_medium) {
            if (typeof slider === 'undefined') {
              slider = $this.slick({
                dots: true,
                arrows: false,
                dotsClass: 'process__dots',
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                customPaging: function(slider, i) {
                  return $('<button type="button" />').text(i + 1);
                },
              });
            }
          }
          else {
            if (typeof slider !== 'undefined') {
              slider.slick('unslick');
              slider = undefined;
            }
          }
        });
      });
    },

    marquee: function() {
      this.$marquee.each(function(index, element) {
        const $this = $(this);
        const marqueeClone = element.querySelector('[data-marquee-clone]');
        const clone = marqueeClone.content.cloneNode(true);
        element.appendChild(clone);

        let speed = jcms.mobile ? 100 : 200;
        const marquee = element.querySelector('[data-marquee-text]');
        let marqueeWidth = marquee.offsetWidth;
        const marqueeClones = Math.ceil(window.innerWidth * 2 / marqueeWidth) - 1;
        const style = document.createElement('style');
        style.id = 'marquee-style-' + index;
        style.type = 'text/css';
        document.body.appendChild(style);

        for (let i = 0; i < marqueeClones; i++) {
          element.appendChild(marqueeClone.content.cloneNode(true));
        }

        gsap.to($this, {
          scrollTrigger: {
            trigger: $this,
            start: 'top bottom',
            end: 'bottom top-=20vh',
            toggleActions: 'restart none reverse reset',
            scrub: window.innerWidth <= jcms.breakpoints.fluid ? 1 : true
          },
          ease: 'none',
          x: window.innerWidth <= jcms.breakpoints.fluid ? '-=80vw' : '-=20vw'
        });
      });
    },

    footerCallouts: function() {
      const $callouts = this.$footerCallouts;
      if ($callouts.hasClass('3-up')) {
        const $calloutItems = $callouts.find('.footer-callout__item');
        let offset = 0;
        $calloutItems.each(function() {
          const $item = $(this);
          gsap.fromTo($item, {
            y: '20%'
          },{
            scrollTrigger: {
              trigger: $callouts,
              start: 'top bottom-=' + offset + '%',
              end: 'bottom bottom-=' + offset + '%',
              toggleActions: 'restart none reverse reset',
              scrub: true
            },
            y: 0
          });
          offset = offset + 5;
        });
      }
    },

    linkActions: function() {
      const newWindowText = ' (opens in new window)';
      this.$links.each(function() {
        let $this = $(this);
        if ($this.attr('target') === '_blank') {
          let aria = $this.attr('aria-label');
          let title = $this.attr('title');
          let text = $this.text();

          if (typeof aria == 'undefined') {
            $this.attr('aria-label', text + newWindowText);
          }
          else if (!aria.includes(newWindowText)) {
            $this.attr('aria-label', aria + newWindowText);
          }

          if (typeof title == 'undefined') {
            $this.attr('title', text + newWindowText);
          }
          else if (!title.includes(newWindowText)) {
            $this.attr('title', title + newWindowText);
          }
        }
      });

      $('[target="embed"]').each(function(){
        var url = $(this).attr('href');

        $(this).attr('data-type', 'iframe').attr('data-src', url).attr('href', '');
      });

      $('[data-fancybox],[target="popup"],[target="embed"],[target="video"]').fancybox({
        hash: false,
        infobar: false,
        idleTime: 60,
        loop: true,
        transitionEffect: "slide",
        buttons: [
          "close"
        ],
        btnTpl: {
          // Arrows
          arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
            '<div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="14.07 6 8 12.07 14.07 18.14 15.57 16.64 11 12.07 15.57 7.5 14.07 6"/></svg></div>' +
            "</button>",
          arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
            '<div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="9.5 6 8 7.5 12.57 12.07 8 16.64 9.5 18.14 15.57 12.07 9.5 6"/></svg></div>' +
            "</button>",
        },
        wheel: false
      });
    },

    wrapRegistered: function() {
      const marks = ['®'];
      marks.forEach(function(mark) {
        $('body *:contains("' + mark + '")').each(function() {
          if (!$(this).get(0).children.length || ($(this).get(0).children.length === 1 && $(this).get(0).children[0].classList.contains('doodle'))) {
            let text = $(this).html();
            text = text.replace(mark, '<sup>' + mark + '</sup>');
            $(this).html(text);
          }
        });
      });
    },

    navToggle: function() {
      const _ = this;

      const classes = {
        show: 'show-header-nav',
        expand: 'expand-header-nav'
      };

      function hideEntireNav() {
        _.$html.removeClass(classes.expand);
        _.$html.removeClass(classes.show);
      }

      function showNav() {
        _.$html.addClass(classes.show);
      }

      function hideNav() {
        _.$html.removeClass(classes.expand);
      }

      function expandNav() {
        _.$html.addClass(classes.expand);
      }

      function toggleNav() {
        if (_.$html.hasClass(classes.expand)) {
          hideNav();
        }
        else {
          showNav();
          expandNav();
        }
      }

      $(window).on('load resize scroll', function() {
        if (window.scrollY > (_.$header.outerHeight() * 2)) {
          showNav();
        }
        else {
          hideEntireNav();
        }
      });

      $('[data-nav-toggle]').click(function() {
        toggleNav();
      });

      $(document).on('click', '.' + classes.expand + ' .page__wrapper', function() {
        hideNav();
      });

      $(document).keyup(function(e) {
        if (e.key === "Escape") {
          hideNav();
        }
      });
    },

    onLoad: function() {
      const _ = this;
      $('html').addClass(_.class.loaded);
    },

    ready: function() {
      this.dom();
      // this.headerShowHide();
      this.navToggle();
      this.slider();
      this.testimonials();
      this.lazyload();
      this.easterEgg();
      this.inViewport();
      this.process();
      this.marquee();
      this.footerCallouts();
      this.linkActions();
      this.wrapRegistered();
    }
  };

  $(function() {
    init.ready();
  });

  $(window).on('load', function() {
    init.onLoad();
  });

})(jQuery);
